import React, { memo } from 'react'

import CloseIcon from '@mui/icons-material/Close'

import { ChipListWrapper, ChipWrapper, StyledChip } from './index.styles'

export interface ChipItemData {
  label: string
  key: string
  metaData?: unknown
}

interface ChipItemProps {
  data: ChipItemData
  onDelete: (i: ChipItemData) => void
}

const ChipItem = memo((props: ChipItemProps) => {
  const { data, onDelete } = props

  return (
    <ChipWrapper>
      <StyledChip
        label={data.label}
        onDelete={() => onDelete(data)}
        variant="outlined"
        /** inline styles is needed here */
        deleteIcon={<CloseIcon style={{ fontSize: 15.5, fill: '#000000' }} data-testid={`${data.key}_delete_chip_icon`} />}
      />
    </ChipWrapper>
  )
})

export interface ChipListProps {
  items: ChipItemData[]
  onDelete: (i: ChipItemData) => void
  renderLabel?: () => JSX.Element
  renderAdditionalItems?: () => JSX.Element
}

const ChipList = (props: ChipListProps) => {
  const { items, onDelete, renderLabel, renderAdditionalItems } = props

  return (
    <ChipListWrapper>
      {renderLabel && renderLabel()}

      {items.map(i => (
        <ChipItem key={i.key} data={i} onDelete={onDelete} />
      ))}

      {renderAdditionalItems && renderAdditionalItems()}
    </ChipListWrapper>
  )
}

export default memo(ChipList)
